import { axios } from '@/request-clients/axios';
import { useMutation } from '@tanstack/react-query';

export const useReportClientInformation = () => {
  return useMutation({
    mutationFn: async (languageCode: 'nl-NL' | 'en-US') => {
      const url = `clients/chat/user-information`;
      const response = await axios.post(url, {
        type: 3, // ClientDeviceType.Web,
        languageCode,
      });

      return response.data;
    },
    retry: false,
  });
};
